export default () => {
  const paths = window.location.pathname.split('/');
  return ['secure', 'secure_ext'].includes(paths[paths.length - 1]);
};
